<template>
  <div id="partners-component" class="text-white mt-4">
    <div class="row ms-0">
      <div class="col-12">
        <div class="row red-color text-center fs-5">
          <div class="col">
            {{ title }}
          </div>
        </div>
      </div>
    </div>
    <div class="row ms-0">
      <div class="col-11 offset-1 border text-center" id="partners-container">
          <img alt="Logos" class="w-50 mb-4 mt-3 border" src="@/assets/partners_click_here.jpg" @click="$router.push('/partners')" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { useLanguageStore } from "@/stores/language";

import { TEXT_KEYS } from "@/constants";

@Options({
  components: {
  }
})
export default class MenuPartners extends Vue {
  languageStore = useLanguageStore()

  get title() {
    return this.languageStore.text(TEXT_KEYS.PARTNERS_TITLE)
  }
}
</script>

<style lang="stylus">
#partners {
  border-color: #e2001a !important
}

#partners-container {
  border-color: #e2001a !important
}

#partners-container > img:hover {
  cursor: pointer
}

#partners-container > img {
  border-color: #e2001a !important
}
</style>